var $ = require('jquery');

module.exports = function ( _super ) {
    var d = _super.d,
        $eh = _super.$eh,
        $logo = $('#emotion-header-logo'),
        isLogoIncluded = ($logo.length) ? true : false,
        $title = $('#emotion-header-title'),
        $titleBg = $('#emotion-header-title-bg'),
        $shopButton = $('#scButton'),
        hasCanvas,
        bgImageManipulationInitialized = false,
        $bgImg,
        $bgImgWrapper,
        bgCanvas,
        $bgCanvas,
        origBgImageLoaded = false,
        $origImage,
        $resizeHelper,
        $bgTmpImg,
        calculations = window.diy.cms.PictureManipulation.Calculations,
        effects = window.diy.cms.PictureManipulation.Effects;

    var self = this,
        logoTimeout,
        logoParams = {};


    this.model = _super.model;

    this.init = function () {
        this.initTitleSettings();
        this.initTitleBgSettings();
        this.initDraggables();

        $bgImg = $('#emotion-header-img', $eh);

        // XXX a fix for a strange FF bug, when image get selected when pressing
        // on "Display background" checkbox
        $bgImg.css('-moz-user-select', 'none');

        $bgImgWrapper = $('#cc-eh-img-wrapper', $eh);
        if ($bgImgWrapper.length == 0) {
            $bgImg.wrap('<div id="cc-eh-img-wrapper"></div>');
            $bgImgWrapper = $('#cc-eh-img-wrapper', $eh);
        }
        $bgImgWrapper.click(function () {
            $(document).trigger('diy-eh-component-clicked', {'elem': $bgImgWrapper});
        });

        // adjust header height in model, because some layouts
        // override layout.ini settings with more specific css rules
        // FIXME: proper fix is to check that all layouts have correct
        // values in layout.ini. Then these 2 lines should be removed
        _super._ignoreDataChange = true;
        this.model.setHeight($eh.height());
        this.model.setWidth($eh.width());
        _super._ignoreDataChange = false;

        this.model.bind('change', this.model.toHandler(this.updateView, this));
        this._super.bind('hide', this._super.toHandler(this.disableAllDraggable, this));
        this._super.bind('open', this._super.toHandler(this.enableAllDraggable, this));
        this.enableAllDraggable();
        this.updateView(this.model, null, this.model.getAll());

        $(document).bind('diy-emotionheader-sectionOpened diy-eh-component-visibility-changed', function (ev, data) {
            var $elements = null;
            if (data.componentName && !data.show) {
                return;
            }
            name = data.tabName || data.componentName;
            $allElements = $title.add($titleBg).add($shopButton).add($logo);
            switch (name) {
                case 'title':
                    $elements = $title.add($titleBg);
                    break;
                case 'titleBg':
                    $elements = $titleBg;
                    break;
                case 'shop':
                    $elements = $shopButton;
                    break;
                case 'logo':
                    $elements = $logo;
                    break;
            }
            if ($elements === null) {
                return;
            }
            $allElements.removeClass('highlight');
            $elements.addClass('highlight');
            setTimeout(function () {
                $elements.removeClass('highlight');
            }, 2000);
        });
    };

    /**
     * Init new calculated title settings if they came as default (-1) from server
     */
    this.initTitleSettings = function () {
        var anchorPos = $title.anchorPosition();
        // Fixed bug DHDIY-21186 - reset to auto container size
        // that was manually set on rendering when container size may be not known yet
        anchorPos.setContainerSize(null, null);
        var titleMeasurements = anchorPos.getBoxMeasurements();
        var realPos = anchorPos.getAnchorPosition();

        var settings = {
            titleHorPos: realPos.left,
            titleVertPos: realPos.top
        };

        for (var name in settings) {
            if (this.model.get(name) == -1) {
                this.model.set(name, settings[name], false, {dataChanged: false});
            }
        }
    };

    /**
     * Init new calculated title background settings if they came as default (-1) from server
     */
    this.initTitleBgSettings = function () {
        var anchorPos = $titleBg.anchorPosition();
        // Fixed bug DHDIY-21186 - reset to auto container size
        anchorPos.setContainerSize(null, null);
        var titleMeasurements = anchorPos.getBoxMeasurements();
        var realPos = anchorPos.getAnchorPosition();
        var headerSize = anchorPos.getContainerSize();

        var settings = {
            titleBackgroundHorPos: realPos.left,
            titleBackgroundVertPos: realPos.top,
            titleBackgroundHeight: Math.round(titleMeasurements.height / headerSize.height * 100)
        };

        for (var name in settings) {
            if (this.model.get(name) == -1) {
                this.model.set(name, settings[name], false, {dataChanged: false});
            }
        }
    };

    this.initDraggables = function () {
        var dragOptions = [
            {
                elem: $title,
                horPosName: 'titleHorPos',
                vertPosName: 'titleVertPos'
            }, {
                elem: $titleBg,
                horPosName: 'titleBackgroundHorPos',
                vertPosName: 'titleBackgroundVertPos'
            }, {
                elem: $shopButton,
                horPosName: 'shopHorPos',
                vertPosName: 'shopVertPos'
            }
        ];
        if (isLogoIncluded) {
            dragOptions.push(
                {
                    elem: $logo,
                    horPosName: 'logoHorPos',
                    vertPosName: 'logoVertPos'
                }
            );
        }

        var createDragHandler = function ($elem, horPosName, vertPosName) {
            return function (e, ui) {
                var pos = $elem.anchorPosition().getAnchorPosition();
                var posOpts = {};
                posOpts[horPosName] = pos.left;
                posOpts[vertPosName] = pos.top;
                self.model.set(posOpts, undefined, {from: self});
            };
        };

        var createStartDragHandler = function ($elem) {
            return function (e, ui) {
                $eh.addClass('eh-drag-in-progress');
                $(document).trigger('diy-eh-component-dragstart', {'elem': $elem});
            };
        };
        var createStopDragHandler = function ($elem) {
            return function (e, ui) {
                $eh.removeClass('eh-drag-in-progress');
                $(document).trigger('diy-eh-component-dragstop', {'elem': $elem});
            };
        };

        for (var i = 0; i < dragOptions.length; ++i) {
            var config = dragOptions[i];
            config.elem.draggable({
                drag: createDragHandler(config.elem, config.horPosName, config.vertPosName),
                start: createStartDragHandler(config.elem),
                stop: createStopDragHandler(config.elem)
            });
            config.elem.click(function () {
                $(document).trigger('diy-eh-component-clicked', {'elem': $(this)});
            });
        }
    };

    this.updateView = function (model, data, changed, extra) {
        if (extra && extra.from == this) {
            return;
        }

        for (var prop in changed) {
            // grab the new value
            var value = changed[prop];

            switch (prop) {
                case 'height':
                    // note that when sliding, a dinamic element
                    // will be created just to mark the height
                    // and only after slider is released, height will be
                    // acutally changed
                    $resizeHelper = $('.cc-eh-settings-resize-helper');
                    if (extra && extra.isChanging) {
                        if ($resizeHelper.length == 0) {
                            $resizeHelper = $('<div class="cc-eh-settings-resize-helper"/>')
                                .appendTo(document.body)
                                .wrap("<div class='diye'></div>");
                            $resizeHelper.offset($eh.offset());
                            $resizeHelper.width($eh.width());
                        }
                        $resizeHelper.height(value);
                    } else {
                        $resizeHelper.unwrap().remove();
                        $eh.height(value);
                        $(document).trigger('CC.EmotionHeader.Preview.onHeaderHeightModified', value);
                    }
                    break;

                default:
                    break;
            }
        }

        this.updateShopButton(changed, extra);
        this.updateTitle(changed, extra);
        this.updateLogo(changed, extra);
        // call the background-image-specific decorators
        this.updateBackground(changed, extra);
    };

    this.updateShopButton = function (changed, extra) {

        // init vars
        var model = this.model;
        var buttonIsVisible = (1 == model.get('shopShowButton')
        && 1 == model.get('shopHasProducts'));
        var defaultCssApplied = false;

        // change the shop button image
        if ('undefined' != typeof(changed['shopId'])) {
            // extract the full image path from the existing one
            var parts = $shopButton.attr('src').split('/');
            parts.pop();
            var path = parts.join('/');
            // override the image
            $shopButton.attr('src', path + '/' + changed['shopId']);
        }

        // set the shop button's CSS
        if ('undefined' != typeof(changed['shopCssStyle'])) {
            // apply style
            $shopButton.attr('style', changed['shopCssStyle']);
            defaultCssApplied = true;
        }

        // update button position if either position
        // or the header height have changed
        if ('undefined' != typeof(changed['shopHorPos'])
            || 'undefined' != typeof(changed['shopVertPos'])
            || 'undefined' != typeof(changed['height'])
        ) {
            // extract values
            var horPos = ('undefined' != typeof(changed['shopHorPos'])
                ? changed['shopHorPos'] : model.get('shopHorPos'));
            var vertPos = ('undefined' != typeof(changed['shopVertPos'])
                ? changed['shopVertPos'] : model.get('shopVertPos'));
            // re-calculate button position in pixels
            var cssPx = $shopButton.anchorPosition().fromAnchorPosition({
                top: (-1 == vertPos ? 0 : vertPos),
                left: (-1 == horPos ? 0 : horPos)
            });
            // convert position to CSS percentages
            var cssPerc = $shopButton.anchorPosition()
                .toPercentPosition(cssPx);
            // if either position is at default
            if (-1 == horPos || -1 == vertPos) {
                // [re]apply CSS default style
                $shopButton.attr('style', model.get('shopCssStyle'));
                defaultCssApplied = true;
            }
            // apply new positions
            var css = {};
            if (-1 != horPos) {
                css.left = cssPerc.left + '%';
                css.right = 'auto';
            }
            if (-1 != vertPos) {
                css.top = cssPerc.top + '%';
                css.bottom = 'auto';
            }
            if (!jQuery.isEmptyObject(css)) {
                $shopButton.css(css);
            }

            // Recalculate draggable containment box
            $shopButton.draggable('option', 'containment', this.getDraggableContainment($shopButton, $eh));
        }

        // if the visibility checkbox changed,
        // or the products have changed,
        // or the default css has overwritten the hidden state
        if ('undefined' != typeof(changed['shopShowButton'])
            || 'undefined' != typeof(changed['shopHasProducts']
            || defaultCssApplied)
        ) {
            // re-enforce visibility state
            $shopButton[(buttonIsVisible ? 'show' : 'hide')]();
        }

    }; // END OF SHOP BUTTON UPDATE

    this.updateTitle = function (changed, extra) {
        var model = this.model, updateText = false, updateBg = false;

        for (var prop in changed) {
            // grab the new value
            var value = changed[prop];

            switch (prop) {
                case 'titleVisible':
                    $title[model.getTitleVisible() ? 'show' : 'hide']();
                case 'titleBackgroundVisible':
                    var showTitle = model.getTitleVisible();
                    var showBg = model.getTitleBackgroundVisible();
                    $titleBg[showTitle && showBg ? 'show' : 'hide']();
                    break;

                case 'font':
                case 'fontWeight':
                case 'fontStyle':
                case 'fontSize':
                case 'title':
                case 'titleHorPos':
                case 'titleVertPos':
                    updateText = true;
                    break;

                case 'fontAlign':
                    $title.css('textAlign', model.getFontAlign());
                    break;

                case 'fontColor':
                    $title.css('color', '#' + model.getFontColor());
                    break;

                case 'titleBackgroundColor':
                    $titleBg.css('background-color', '#' + model.getTitleBackgroundColor());
                    break;

                case 'titleBackgroundHorPos':
                case 'titleBackgroundVertPos':
                case 'titleBackgroundWidth':
                case 'titleBackgroundHeight':
                    updateBg = true;
                    break;

                case 'titleBackgroundOpacity':
                    $titleBg.css('opacity', model.getTitleBackgroundOpacity() / 100);
                    break;
                case 'width':
                case 'height':
                    updateText = true;
                    /**
                     * @cancel height is set directly through model _set method & doesn't update titleBackgroundHeight
                     * which results in no preview update
                     */
                    if (typeof extra === 'object' && typeof extra.action === 'string' && extra.action === 'cancel') {
                        updateBg = true;
                    }
                    break;
            }
        }

        if (updateText) {
            $title.css({
                fontFamily: model.getFont(),
                fontWeight: model.getFontWeight(),
                fontStyle: model.getFontStyle(),
                fontSize: model.getFontSize() + 'px'
            });
            var titleText = model.getTitle();
            $.browser.msie ? $title.html(titleText.replace(/ /g, "&nbsp;").replace(/\n/g, "<br />")) : $title.text(titleText);

            /* Recalculate text css position based on the new text measurements and sliders */
            var sliderValues = {
                left: model.getTitleHorPos(),
                top: model.getTitleVertPos()
            };

            var newCssPos = $title.anchorPosition().fromAnchorPosition(sliderValues);
            var percentPos = $title.anchorPosition().toPercentPosition(newCssPos);

            $title.css({
                left: percentPos.left + '%',
                top: percentPos.top + '%'
            });

            // Recalculate draggable containment box
            $title.draggable('option', 'containment', this.getDraggableContainment($title, $eh));
        }

        if (updateBg) {
            $titleBg.css('width', model.getTitleBackgroundWidth() + '%');
            $titleBg.css('height', Math.round(model.getTitleBackgroundHeight() * model.getHeight() / 100));

            /* Recalculate text bg css position based on the new bg measurements and sliders */
            var sliderValues = {
                left: model.getTitleBackgroundHorPos(),
                top: model.getTitleBackgroundVertPos()
            };

            var newCssPos = $titleBg.anchorPosition().fromAnchorPosition(sliderValues);
            var percentPos = $titleBg.anchorPosition().toPercentPosition(newCssPos);

            $titleBg.css({
                left: percentPos.left + '%',
                top: percentPos.top + '%'
            });

            // Recalculate draggable containment box
            $titleBg.draggable('option', 'containment', this.getDraggableContainment($titleBg, $eh));
        }
    };

    this.updateLogo = function (changed, extra) {
        if (!isLogoIncluded) return;

        var model = this.model, update = false;

        for (var prop in changed) {
            // grab the new value
            var value = changed[prop];

            switch (prop) {
                case 'logoVisible':
                    $logo[value && !model.getLogoDeleted() ? 'show' : 'hide']();
                    break;

                case 'logoDeleted':
                    $logo[!value && model.getLogoVisible() ? 'show' : 'hide']();
                    break;

                case 'logoUrl':
                    if (value) {
                        $logo.attr('src', value);
                    }
                    if (value && model.getLogoVisible()) {
                        $logo.show();
                    }
                    break;

                case 'logoBorderVisible':
                    update = true;
                    break;

                case 'logoOriginalWidth':
                case 'logoOriginalHeight':
                case 'logoZoom':
                case 'logoHorPos':
                case 'logoVertPos':
                case 'logoPadding':
                case 'logoBorderSize':
                    update = true;
                    break;

                case 'logoBorderColor':
                    $logo.css('borderColor', '#' + value);
                    break;

                case 'width':
                case 'height':
                    /**
                     * @cancel height is set directly through model _set method and doesn't update logoZoom
                     * which results in no preview update
                     */
                    if (typeof extra === 'object' && typeof extra.action === 'string' && extra.action === 'cancel') {
                        update = true;
                    }
                    break;
            }
        }

        if (model.getLogoDeleted()) return;

        if (update) {
            var logoBorderVisible = model.getLogoBorderVisible(),
                originalWidth = model.getLogoOriginalWidth(),
                originalHeight = model.getLogoOriginalHeight(),
                size = {width: 0, height: 0};

            var orientation = model.getWidth() / originalWidth > model.getHeight() / originalHeight ? 'height' : 'width';
            var outer = logoBorderVisible ? 2 * model.getLogoBorderSize() + 2 * model.getLogoPadding() : 0;
            var ratio = originalWidth / originalHeight;

            if (orientation == 'width') {
                size.width = Math.max(model.getLogoZoom() / 100 * model.getWidth() - outer, 1);
                size.height = size.width / ratio;
            }
            else {
                size.height = Math.max(model.getLogoZoom() / 100 * model.getHeight() - outer, 1);
                size.width = size.height * ratio;
            }

            $logo.css({
                'width': Math.round(size.width) + 'px',
                'height': Math.round(size.height) + 'px',
                'padding': logoBorderVisible ? model.getLogoPadding() + 'px' : 0,
                'border': logoBorderVisible ? model.getLogoBorderSize() + 'px solid #' + model.getLogoBorderColor() : 0
            });

            var anchor = $logo.anchorPosition();
            var cssPos = anchor.fromAnchorPosition({
                left: model.getLogoHorPos(),
                top: model.getLogoVertPos()
            });
            var percentPos = anchor.toPercentPosition(cssPos);

            $logo.css({
                'left': percentPos.left + '%',
                'top': percentPos.top + '%'
            });

            // Recalculate draggable containment box
            $logo.draggable('option', 'containment', this.getDraggableContainment($logo, $eh));
        }
    };

    hasCanvas = (function () {
        var tmp = document.createElement('canvas');
        if (!tmp.getContext) {
            return false;
        }
        if (!tmp.getContext('2d')) {
            return false;
        }
        if (!tmp.getContext('2d').getImageData) {
            return false;
        }
        return true;
    })();

    this.updateBackground = function (changed, extra) {

        if (_backgroundDisabledByLayout) return;

        var doUpdate = false, x, val;
        for (x in changed) {
            val = changed[x];
            switch (x) {
                case 'backgroundVisible':
                    var bgVisibility = val ? 'visible' : 'hidden';
                    $bgImgWrapper.css('visibility', bgVisibility);
                    $bgImg.css('visibility', bgVisibility);
                    if (hasCanvas) {
                        $bgCanvas = $('#cc-eh-img-preview', $eh);
                        $bgCanvas.css('visibility', bgVisibility);
                    }
                    if ($origImage) {
                        if (bgVisibility == 'hidden') {
                            $origImage.data('bk-visibility', $origImage.css('visibility'));
                            $origImage.css('visibility', bgVisibility);
                        } else {
                            var bkVisibility = $origImage.data('bk-visibility');
                            if (bkVisibility) {
                                $origImage.data('bk-visibility', '');
                                $origImage.css('visibility', bkVisibility);
                            } else {
                                $origImage.css('visibility', bgVisibility);
                            }
                        }
                    }
                    doUpdate = true;
                    break;
                case 'bgImageUrl':
                    loadOrigBgImage(this.model.getBgImageUrl());
                    doUpdate = true;
                    break;
                case 'rotate':
                case 'brightness':
                case 'sharpen':
                case 'backgroundOriginalWidth':
                case 'backgroundOriginalHeight':
                case 'backgroundZoom':
                case 'backgroundHorPos':
                case 'backgroundVertPos':
                    doUpdate = true;
                    break;
                // variable width is not supported at the moment
                // but the logic is the same
                case 'width':
                case 'height':
                    if (!extra || !extra.isChanging) {
                        doUpdate = true;
                    }
                    break;

                case 'bgColor':
                    $eh.css('background-color',
                        val
                        && !_backgroundDisabledByLayout
                        && !_backgroundColorDisabledByLayout
                            ? '#' + val : 'transparent');
                    break;
            }
        }
        if (doUpdate) {
            // we initialize needed components for image edit
            // only on first update. Until then we keep showing
            // the image prepared by server (this is especially useful for keyvisuals
            // because we don't know how precropped image was cropped from the original
            // keyvisual image)
            if (!bgImageManipulationInitialized) {
                initializeBgImageManipulation();
                bgImageManipulationInitialized = true;
            }
            if (this.model.getBackgroundEdited() == 1) {
                if (hasCanvas && !this.model.getBackgroundAnimated()) {
                    this.doUpdateBackground(changed);
                } else if (this.model.getBrightness() != 0
                    || this.model.getSharpen() != 0
                    || this.model.getRotate() != 0
                ) {
                    this.doUpdateBackgroundNoCanvas(changed, extra);
                } else {
                    // this is just repositioning when no canvas support
                    // no server call required
                    var zoom = getBackgroundZoomRatio();
                    $origImage.css({
                        width: this.model.getBackgroundOriginalWidth() * zoom,
                        height: this.model.getBackgroundOriginalHeight() * zoom
                    });
                    $bgImg.hide();
                    $origImage.css({
                        visibility: this.model.getBackgroundVisible() ? 'visible' : 'hidden',
                        left: -this.model.getBackgroundHorPos() / 100.0 * ($origImage.width() - this.model.getWidth()),
                        top: -this.model.getBackgroundVertPos() / 100.0 * ($origImage.height() - this.model.getHeight())
                    });
                }
            } else {
                this.doUpdateBackgroundNoCanvas(changed, extra);
            }
        }
    };

    var initializeBgImageManipulation = function () {
        if (hasCanvas) {
            $bgCanvas = $('#cc-eh-img-preview', $eh);
            if (!$bgCanvas.length) {
                bgCanvas = document.createElement('canvas');
                $bgCanvas = $(bgCanvas);
                $bgCanvas.attr('id', 'cc-eh-img-preview');
                $bgImgWrapper.prepend(bgCanvas);
            } else {
                bgCanvas = $bgCanvas[0];
            }
        }
    };

    var getBackgroundZoomRatio = function () {
        var
            m = self.model,
            origSize,
            size,
            bgMaxZoom = m.getBackgroundMaxZoom(),
            width = m.getWidth(),
            height = m.getHeight(),
            origWidth = m.getBackgroundOriginalWidth(),
            origHeight = m.getBackgroundOriginalHeight()
            ;
        if (width / origWidth > height / origHeight) {
            origSize = origWidth;
            size = width;
        } else {
            origSize = origHeight;
            size = height;
        }
        var
            onePercentPx = Math.max(0, ((bgMaxZoom / 100) * origSize - size) / (bgMaxZoom - 100)),
            zoomPx = onePercentPx * (m.getBackgroundZoom() - 100) + size,
            zoom = zoomPx / origSize
            ;
        return zoom;
    };

    this.doUpdateBackground = function (changed) {
        if (!origBgImageLoaded) {
            $origImage.one('load', function () {
                self.doUpdateBackground.call(self, changed);
            });
            return;
        }
        var context = bgCanvas.getContext('2d'), m = this.model;

        $bgCanvas.show();
        $bgCanvas.attr('width', m.getWidth());
        $bgCanvas.attr('height', m.getHeight());

        context.save();
        context.clearRect(0, 0, bgCanvas.width, bgCanvas.height);

        // POSITIONING
        var
            origWidth = m.getBackgroundOriginalWidth(),
            origHeight = m.getBackgroundOriginalHeight(),
            ehWidth = m.getWidth(),
            ehHeight = m.getHeight(),
            horPos = m.getBackgroundHorPos() / 100,
            vertPos = m.getBackgroundVertPos() / 100,
        // calculate the zoom to be applied to the
        // original image, we will scale the canvas with that value
            zoom = getBackgroundZoomRatio(),
            zoomWidth = origWidth * zoom,
            zoomHeight = origHeight * zoom,
        // calculating zoomed image corner coordinates
        // when axis origin is the center of the emotion header,
            zoomTopLeft = {
                x: -(ehWidth / 2 + horPos * (zoomWidth - ehWidth)),
                y: -(ehHeight / 2 + vertPos * (zoomHeight - ehHeight))
            },
            fitZoom = 1
            ;

        // ROTATION
        var rotate = m.getRotate();
        if (rotate != 0) {
            // after this rotation there may be some header zones uncovered by image
            // so, we detect this and zoom in so that this will be corrected
            var
                zoomCoords = [
                    zoomTopLeft,
                    {x: zoomTopLeft.x + zoomWidth, y: zoomTopLeft.y},
                    {
                        x: zoomTopLeft.x + zoomWidth,
                        y: zoomTopLeft.y + zoomHeight
                    },
                    {x: zoomTopLeft.x, y: zoomTopLeft.y + zoomHeight}
                ],
            // calculate coordinates of rotated zoom image
                rotZoomCoords = calculations.getRotatedPointsCoordinates(zoomCoords, rotate),
                ehBox = [
                    {x: -ehWidth / 2, y: -ehHeight / 2},
                    {x: ehWidth / 2, y: -ehHeight / 2},
                    {x: ehWidth / 2, y: ehHeight / 2},
                    {x: -ehWidth / 2, y: ehHeight / 2}
                ]
                ;
            fitZoom = calculations.getZoomToFit(ehBox, rotZoomCoords);
            zoom = zoom * fitZoom;
        }

        context.scale(zoom, zoom);

        context.translate(
            ehWidth / 2 / zoom,
            ehHeight / 2 / zoom
        );

        context.rotate(Math.PI / 180 * rotate);

        // DRAW IMAGE
        context.drawImage($origImage[0],
            zoomTopLeft.x / zoom * fitZoom,
            zoomTopLeft.y / zoom * fitZoom
        );
        context.restore();

        // SHARPEN & BRIGHTNESS
        var sharpen = m.getSharpen();
        var brightness = m.getBrightness();
        if (sharpen != 0 || brightness != 0) {
            var dt = context.getImageData(0, 0, bgCanvas.width, bgCanvas.height);
        }
        if (sharpen != 0) {
            var dtcopy = context.getImageData(0, 0, bgCanvas.width, bgCanvas.height);
            effects.doSharpnessBlur(sharpen, dt, dtcopy);
        }
        if (brightness != 0) {
            effects.doBrightness(brightness, 0, dt);
        }
        if (sharpen != 0 || brightness != 0) {
            context.putImageData(dt, 0, 0);
        }

        // hide image, just in case it has some transparency to not create a ghosting effect
        $bgImg.hide();
        $bgImg.addClass('eh-img-preview-background'); // TODO is this really needed?
    };

    var loadOrigBgImage = function (imgUrl) {
        origBgImageLoaded = false;
        if (!$origImage) {
            $origImage = $('#eh-bg-orig-image', $eh);
            if (!$origImage.length) {
                $origImage = $('<img id="eh-bg-orig-image" />');
                $origImage.css({
                    visibility: 'hidden',
                    position: 'absolute'
                });
                $bgImgWrapper.append($origImage);
            }
        }
        $origImage.removeAttr('src');
        $origImage.one('load', function () {
            var origWidth = $origImage.width(), origHeight = $origImage.height();
            // we should get the original size of the new image
            $origImage.width('auto');
            $origImage.height('auto');
            var newOrigWidth = $origImage.width(), newOrigHeight = $origImage.height();
            // restore the previous width, resising is done elsewhere
            // so we don't want to change anything here
            $origImage.width(origWidth);
            $origImage.height(origHeight);
            self.model.set({
                backgroundOriginalWidth: newOrigWidth,
                backgroundOriginalHeight: newOrigHeight
            }, undefined, {dataChanged: false});
            origBgImageLoaded = true;
        });
        $origImage.attr('src', imgUrl);
    };

    var getPrepImageUrl = function (m) {
        var prepImageUrl = m.getBgImageUrl(),
            bgSettings = m.getBgImageSettings()
            ;

        // appending to the url param for picture manipulation
        for (var x in bgSettings) {
            if (bgSettings.hasOwnProperty(x)) {
                prepImageUrl += '&' + x + '=' + bgSettings[x];
            }
        }

        // appending to the url params for current header size
        prepImageUrl += '&width=' + m.getWidth();
        prepImageUrl += '&height=' + m.getHeight();

        return prepImageUrl;
    };

    this.doUpdateBackgroundNoCanvas = function (changed, extra) {
        // we should initiate remote actions only after setting is changed
        // (like when slider is released)
        if (extra && extra.isChanging) return;

        var m = this.model,
            prepImageUrl = getPrepImageUrl(m);

        $(document).trigger('CC.EmotionHeader.Preview.onTaskStarted');
        $bgTmpImg = $('<img />');
        $bgTmpImg.one('load', function () {
            /* though getPrepImageUrl function is also called above and
             * stored in prepImageUrl, we'll call it again
             * as we need it's new data when the image
             * has been loaded */
            $bgImg.attr('src', getPrepImageUrl(m));
            if (hasCanvas) {
                $bgCanvas.hide();
            }
            $bgImg.show();
            $origImage.css('visibility', 'hidden');
            $bgTmpImg.remove();
            $(document).trigger('CC.EmotionHeader.Preview.onTaskCompleted');
        });
        $bgTmpImg.attr('src', prepImageUrl);
    };

    this.destroy = function () {
        //$logo.add($title).draggable('destroy');
    };

    this.disableAllDraggable = function () {
        this.setAllDraggable(false);
    };

    this.enableAllDraggable = function () {
        this.setAllDraggable(true);
    };
    this.setAllDraggable = function (enable) {
        var
            $elements,
            elements = [$title, $titleBg, $shopButton];

        if (isLogoIncluded) {
            elements.push($logo);
        }
        $elements = $(elements).map(function () {
            return this.toArray();
        });

        $elements.draggable("option", "disabled", !enable);
    };

    this.getDraggableContainment = function ($elem, $parent) {
        var parentOffset = $parent.offset();
        return [
            parentOffset.left,
            parentOffset.top,
            parentOffset.left + Math.max(0, $parent.innerWidth() - $elem.outerWidth()),
            parentOffset.top + Math.max(0, $parent.innerHeight() - $elem.outerHeight())
        ];
    };

    // this exposes the slider position
    // for the shop button to other tabs (shop)
    this.shopButtonSliderPosition = function () {
        return $shopButton.anchorPosition().getAnchorPosition();
    };
};



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/module/emotion-header/CC.EmotionHeader.Preview.js
 ** module id = 876
 ** module chunks = 0
 **/